export const DORMANT_CUSTOMERS_CHANGE_TRACKING = {
  takeCustomer: {
    source: 'dormant_customers.take_customer',
    id: 20001,
  },
  toggleInterestStatus: {
    source: 'dormant_customers.toggle_interest_status',
    id: 20002,
  },
  removeClaimedCustomer: {
    source: 'dormant_customers.remove_claimed_customer',
    id: 20003,
  },
} as const;
